export default "<div id=\"container\">\r\n\r\n  <div [style.color]=\"color\" class=\"top-box\" id=\"top-box{{idCanvas}}\">{{counter}}</div>\r\n\r\n</div>"